<template> 
  <router-view/>
</template>
<script>
export default {
  sockets: {
    app_client_side_updated()
    {
      //console.log("app_client_side_updated")
      this.showMessage("error",this.$store.state.languages.lang_phrases.uygulama_icin_yeni_guncellemeler_var,this.$store.state.languages.lang_phrases.saniye_icinde_yeniden_yuklenecek)
      setTimeout(()=>{
        location.reload();
      },5000)
      

    },
    initial(data) {
        //console.log("%c "+data+" ","color:white;background-color:#352f8d;font-weight:light;")
        this.$store.dispatch('auth/setSocketConnected',false)
        if(this.$store.state.auth.user)
        {
          this.$socket.emit('create_user_channel', { client: this.$store.state.auth.user.uuid })
        }        
    },
    user_socket_created(data) {
      //console.log("%c User socket created ","color:white;background-color:#352f8d;font-weight:light;")
        //console.log(data);
        this.$store.dispatch('auth/setSocketConnected',true)
    },
    admin_socket_created(data) {
      //console.log("%c Admin socket created "+data,"color:white;background-color:#352f8d;font-weight:light;")
        //console.log(data);        
    },
    supplier_socket_created(data) {
      //console.log("%c Supplier socket created "+data,"color:white;background-color:#352f8d;font-weight:light;")
        //console.log(data);        
    },
    usersocket(data) {
        
        console.log(data);
    },
    ticket_answered(data) {
        
        this.$store.dispatch('tickets/setOpenTicketsCount',data) 
    },
    supplier_notification_published(data) {
        
        //this.$store.dispatch('auth/setSupplierNotifications',data) 
        this.getSupplierOpenNotifications()
    },
    unsupported_tickets_detected(data) {        
        this.$store.dispatch('tickets/setAdminOpenTickets',true) 
        this.$store.dispatch('tickets/setAdminOpenTicketsCount',data) 
        //this.$store.dispatch('tickets/setOpenTicketsCount',data) 
    },
  }, 
  mounted()
  {
    this.getUserIp()
  }
  

}

</script>
<style lang="css">

</style>
